import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '@hta/auth';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
    const snack = inject(MatSnackBar);
    const auth = inject(AuthService);
    const router = inject(Router);

    return next(req).pipe(
        catchError((err: HttpErrorResponse) => {
            if (err.status === 401) {
                auth.signOut().then(() => router.navigate(['/sign-in']));
            } else if (err.status === 403) {
                snack.open('Sin permiso para esta acción', 'Cerrar', { duration: 3500 });
            } else if (err.status === 429) {
                snack.open('Demasiadas solicitudes. Espera un momento.', 'Cerrar', { duration: 4000 });
            } else if (err.status >= 500) {
                snack.open('Error del servidor. Intenta más tarde.', 'Cerrar', { duration: 4000 });
            }
            return throwError(() => err);
        })
    );
};
